<template>
  <div class="p-6">
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        Componentes
      </h1>
      <p class="text-gray-600 dark:text-gray-400">
        Catálogo de componentes
      </p>
    </div>
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
      <div class="p-6 border-b border-gray-200 dark:border-gray-700">
        <div class="flex justify-between items-center">
          <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
            Lista de Componentes
          </h2>
          <button @click="showModal = true" class="bg-violet-600 hover:bg-violet-700 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
            Nuevo Componente
          </button>
        </div>
        <!-- Filtros -->
        <form @submit.prevent="onFilter" class="flex flex-wrap gap-2 mt-4">
          <input v-model="filters.nombre" type="text" placeholder="Nombre" class="px-3 py-2 rounded border text-sm bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200" />
          <select v-model="filters.tipo_componente_id" class="px-3 py-2 rounded border text-sm bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200">
            <option value="">Todos los tipos</option>
            <option v-for="tipo in tiposComponente" :key="tipo.id" :value="tipo.id">{{ tipo.nombre }}</option>
          </select>
          <button type="submit" class="px-4 py-2 rounded bg-blue-500 text-white text-sm font-semibold hover:bg-blue-600 transition">Buscar</button>
          <button type="button" @click="onClearFilters" class="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 text-sm font-semibold hover:bg-gray-300 dark:hover:bg-gray-600 transition">Limpiar</button>
        </form>
      </div>
      <div class="p-6">
        <div v-if="error" class="text-red-500 text-center mb-4">{{ error }}</div>
        <div class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs uppercase bg-gray-100 dark:bg-gray-800 dark:text-gray-300 border-b-2 border-gray-200 dark:border-gray-700">
              <tr>
                <th class="px-4 py-2 font-bold">ID</th>
                <th class="px-4 py-2 font-bold">Nombre</th>
                <th class="px-4 py-2 font-bold">Tipo Componente</th>
                <th class="px-4 py-2 font-bold">Costo Unitario</th>
                <th class="px-4 py-2 font-bold">Precio Unitario</th>
                <th class="px-4 py-2 font-bold">Estado</th>
                <th class="px-4 py-2 font-bold">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="componente in componentes" :key="componente.id" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 even:bg-gray-50 dark:even:bg-gray-700">
                <td class="px-4 py-2 font-medium text-gray-900 dark:text-white">{{ componente.id }}</td>
                <td class="px-4 py-2 text-gray-700 dark:text-gray-200">{{ componente.nombre }}</td>
                <td class="px-4 py-2 text-gray-700 dark:text-gray-200">{{ componente.tipo_componente?.nombre || 'Sin tipo' }}</td>
                <td class="px-4 py-2 text-gray-700 dark:text-gray-200">${{ componente.costo_unitario }}</td>
                <td class="px-4 py-2 text-gray-700 dark:text-gray-200">${{ componente.precio_unitario }}</td>
                <td class="px-4 py-2">
                  <span v-if="componente.activo" class="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full dark:bg-green-900 dark:text-green-300">Activo</span>
                  <span v-else class="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded-full dark:bg-red-900 dark:text-red-300">Inactivo</span>
                </td>
                <td class="px-4 py-2 whitespace-nowrap text-right">
                  <button @click="openEditModal(componente)" class="text-blue-500 hover:text-blue-700 mr-2" title="Editar">
                    <svg class="w-5 h-5 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536M9 13h3l8-8a2.828 2.828 0 00-4-4l-8 8v3z"/>
                    </svg>
                  </button>
                  <button @click="onDeleteComponente(componente)" class="text-red-500 hover:text-red-700" title="Eliminar">
                    <svg class="w-5 h-5 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>
                </td>
              </tr>
              <tr v-if="componentes.length === 0">
                <td colspan="8" class="text-center py-4 text-gray-400">No hay componentes para mostrar.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Paginador -->
        <Pagination 
          :current-page="currentPage" 
          :last-page="lastPage" 
          @page-changed="goToPage" 
        />
      </div>
    </div>
    <!-- Modal para Nuevo/Editar Componente -->
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div class="p-6 border-b border-gray-200 dark:border-gray-700">
          <div class="flex justify-between items-center">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
              {{ editMode ? 'Editar Componente' : 'Nuevo Componente' }}
            </h3>
            <button @click="closeModal" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
        </div>
        <form @submit.prevent="editMode ? updateComponente() : createComponente()" class="p-6 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de Componente *</label>
            <select v-model="componenteForm.tipo_componente_id" required class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white">
              <option value="">Seleccione un tipo</option>
              <option v-for="tipo in tiposComponente" :key="tipo.id" :value="tipo.id">{{ tipo.nombre }}</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nombre *</label>
            <input v-model="componenteForm.nombre" type="text" required class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white" placeholder="Ingrese el nombre" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Costo Unitario *</label>
            <input v-model="componenteForm.costo_unitario" type="number" step="0.01" min="0" required class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white" placeholder="0.00" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Precio Unitario *</label>
            <input v-model="componenteForm.precio_unitario" type="number" step="0.01" min="0" required class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white" placeholder="0.00" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de Costo *</label>
            <select v-model="componenteForm.tipo_costo" required class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white">
              <option value="UNICO">Único - Se suma tal como está</option>
              <option value="POR_MEDIDA">Por Medida - Se multiplica por área del producto</option>
            </select>
            <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
              <span class="font-medium">Único:</span> El costo se suma directamente al total.<br>
              <span class="font-medium">Por Medida:</span> El costo se multiplica por el área (alto × ancho) del producto.
            </p>
          </div>
          <div>
            <label class="flex items-center">
              <input v-model="componenteForm.activo" type="checkbox" class="rounded border-gray-300 text-violet-600 shadow-sm focus:ring-violet-500 focus:ring-offset-0" />
              <span class="ml-2 text-sm text-gray-700 dark:text-gray-300">Activo</span>
            </label>
          </div>
          <div class="flex justify-end space-x-3 pt-4">
            <button type="button" @click="closeModal" class="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 rounded-md hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors">Cancelar</button>
            <button type="submit" :disabled="loading" class="px-4 py-2 bg-violet-600 text-white rounded-md hover:bg-violet-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2">
              <svg v-if="loading" class="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
              </svg>
              {{ loading ? (editMode ? 'Actualizando...' : 'Creando...') : (editMode ? 'Actualizar' : 'Crear') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watchEffect, onMounted } from 'vue'
import { useHttp } from '@/composables/useHttp'
import Swal from 'sweetalert2'
import Pagination from '@/components/Pagination.vue'

const componentes = ref([])
const tiposComponente = ref([])
const currentPage = ref(1)
const lastPage = ref(1)
const perPage = 12
const showModal = ref(false)
const editMode = ref(false)
const componenteForm = ref({ 
  id: null, 
  tipo_componente_id: '', 
  nombre: '', 
  costo_unitario: '',
  precio_unitario: '',
  tipo_costo: 'UNICO',
  activo: true 
})
const filters = ref({ nombre: '', tipo_componente_id: '' })
const { get, post, del, loading, error, data } = useHttp()

const fetchTiposComponente = async () => {
  try {
    await get('tipos-componentes?page=1&per_page=100')
    if (data.value) {
      if (Array.isArray(data.value)) {
        tiposComponente.value = data.value
      } else {
        tiposComponente.value = data.value.data || []
      }
    }
  } catch (err) {
    tiposComponente.value = []
  }
}

const fetchComponentes = async (page = 1) => {
  try {
    const params = new URLSearchParams()
    params.append('page', page)
    params.append('per_page', perPage)
    if (filters.value.nombre) params.append('nombre', filters.value.nombre)
    if (filters.value.tipo_componente_id) params.append('tipo_componente_id', filters.value.tipo_componente_id)
    await get(`componentes?${params.toString()}`)
    if (data.value) {
      if (Array.isArray(data.value)) {
        componentes.value = data.value
        currentPage.value = 1
        lastPage.value = 1
      } else {
        componentes.value = data.value.data
        currentPage.value = data.value.current_page
        lastPage.value = data.value.last_page
      }
    }
  } catch (err) {
    componentes.value = []
  }
}


const goToPage = (page) => {
  if (page >= 1 && page <= lastPage.value) fetchComponentes(page)
}

const onFilter = () => { fetchComponentes(1) }
const onClearFilters = () => { 
  filters.value = { nombre: '', tipo_componente_id: '' }
  fetchComponentes(1) 
}

const closeModal = () => {
  showModal.value = false
  editMode.value = false
  componenteForm.value = { 
    id: null, 
    tipo_componente_id: '', 
    nombre: '', 
    costo_unitario: '',
    precio_unitario: '',
    tipo_costo: 'UNICO',
    activo: true 
  }
}

const openEditModal = (componente) => {
  componenteForm.value = { 
    ...componente,
    tipo_componente_id: componente.tipo_componente_id || '',
    tipo_costo: componente.tipo_costo || 'UNICO'
  }
  showModal.value = true
  editMode.value = true
}

const createComponente = async () => {
  try {
    const payload = {
      tipo_componente_id: componenteForm.value.tipo_componente_id,
      nombre: componenteForm.value.nombre,
      costo_unitario: componenteForm.value.costo_unitario,
      precio_unitario: componenteForm.value.precio_unitario,
      tipo_costo: componenteForm.value.tipo_costo,
      activo: componenteForm.value.activo
    }
    await post('componentes', payload)
    closeModal()
    await fetchComponentes(currentPage.value)
    Swal.fire({ icon: 'success', title: 'Componente creado', text: 'El componente se creó exitosamente.', timer: 2000, showConfirmButton: false })
  } catch (err) {
    Swal.fire({ icon: 'error', title: 'Error', text: error.value || 'Error desconocido al crear componente' })
  }
}

const updateComponente = async () => {
  try {
    const payload = {
      tipo_componente_id: componenteForm.value.tipo_componente_id,
      nombre: componenteForm.value.nombre,
      costo_unitario: componenteForm.value.costo_unitario,
      precio_unitario: componenteForm.value.precio_unitario,
      tipo_costo: componenteForm.value.tipo_costo,
      activo: componenteForm.value.activo
    }
    await post(`componentes/${componenteForm.value.id}?_method=PUT`, payload)
    closeModal()
    await fetchComponentes(currentPage.value)
    Swal.fire({ icon: 'success', title: 'Componente actualizado', text: 'El componente se actualizó exitosamente.', timer: 2000, showConfirmButton: false })
  } catch (err) {
    Swal.fire({ icon: 'error', title: 'Error', text: error.value || 'Error desconocido al actualizar componente' })
  }
}

const onDeleteComponente = async (componente) => {
  const result = await Swal.fire({
    title: `¿Eliminar componente?`,
    text: `¿Seguro que deseas eliminar "${componente.nombre}"? Esta acción no se puede deshacer.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
  })
  if (result.isConfirmed) {
    try {
      await del(`componentes/${componente.id}`)
      await Swal.fire({ title: '¡Eliminado!', text: 'El componente ha sido eliminado correctamente.', icon: 'success', timer: 1800, showConfirmButton: false })
      fetchComponentes(currentPage.value)
    } catch (err) {
      Swal.fire('Error', 'No se pudo eliminar el componente.', 'error')
    }
  }
}

onMounted(() => {
  fetchTiposComponente()
})

watchEffect(() => { fetchComponentes(currentPage.value) })
</script>